import { connect } from 'react-redux'
import Title from '../components/Title'
import { getEnv } from 'aria-viewer/utils/environment'

const getTitle = state => {
    const shouldDisplayVersioning = getEnv('NODE_ENV') === 'production' ? state.getIn(['stats', 'enableStats']) : true

    return shouldDisplayVersioning
        ? `v${state.getIn(['device', 'appVersion'])} ${state.getIn(['tour', 'tourTitle'])}`
        : state.getIn(['tour', 'tourTitle'])
}

const mapStateToProps = state => ({
    title: getTitle(state),
})

export default connect(mapStateToProps)(Title)
